/**
 * Regras puras da ordem das colunas (P2-03 · D7), separadas do DOM para teste.
 * Fixas: a 1ª coluna, a 1ª coluna COM NOME (quando a 1ª é só o botão de detalhes, ex.: Entidades), sem título e "Ações".
 */
export const ehFixa = (nome: string, i: number, nomes: string[]) => i === 0 || i === nomes.findIndex((x) => x !== '') || nome === '' || /^Aç(ão|ões)$/i.test(nome);

/**
 * Posições ORIGINAIS na ordem final: as fixas ficam no próprio lugar; as móveis preenchem as vagas na ordem gravada
 * (nomes); as que não constam da ordem gravada seguem na ordem do padrão.
 */
export function posicoesFinais(nomes: string[], ordem: string[]): number[] {
  const moveis = nomes.map((nome, i) => ({ nome, i })).filter(({ nome, i }) => !ehFixa(nome, i, nomes));
  const escolhidos = [...ordem.map((x) => moveis.find((m) => m.nome === x)).filter((m): m is { nome: string; i: number } => Boolean(m)), ...moveis.filter((m) => !ordem.includes(m.nome))];
  let k = 0;
  return nomes.map((nome, i) => (ehFixa(nome, i, nomes) ? i : escolhidos[k++].i));
}

/**
 * O que gravar ao "Aplicar": a ordem escolhida só é guardada quando DIFERE do padrão; igual ao padrão (inclusive
 * depois de "Restaurar padrão") grava lista vazia = sem preferência, para a lista acompanhar mudanças futuras do padrão.
 */
export const ordemParaGravar = (escolhida: string[], padrao: string[]) => (escolhida.length === padrao.length && escolhida.every((x, i) => x === padrao[i]) ? [] : escolhida);
